import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
  Box,
  ButtonBase,
  Grid,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import { ReactComponent as RightIcon } from '../../../../assets/img/icon/Right.svg';
import MisPagosIcon from '../../../../assets/img/misPagos_orange.svg';
// import MisPagosIcon from '../../../../assets/img/misPagos.svg';
import ModificarMedioPagoIcon from '../../../../assets/img/modificarMedioPago_orange.svg';
// import ModificarMedioPagoIcon from '../../../../assets/img/modificarMedioPago.svg';
import SubHeader from '../../../../components/Header/SubHeader.component';
import SuraCard from '../../../../components/SuraCard';

const CARDS = [
  {
    link: '/account/payments',
    title: 'Mis pagos',
    content: 'Consultá el estado de tus cuotas',
    image: MisPagosIcon,
  },
  {
    link: '/account/modified_payments',
    title: 'Modificar medio de pago',
    content: 'Modificá el medio de pago para tus productos',
    image: ModificarMedioPagoIcon,
  },
];

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    label: {
      color: '#768692',
    },
    subLabel: {
      color: '#393B3D',
      fontWeight: 500,
    },
    contactBoxes: {
      marginRight: '70px',
      marginBottom: '12px',
    },
    suraCard: {
      display: 'grid',
      minHeight: '80px',
      [theme.breakpoints.up('sm')]: {
        minHeight: '100px',
      },
    },
    title: {
      color: '#000',
      fontWeight: 500,
      fontSize: '20px',
      marginBottom: '8px',
      [theme.breakpoints.down('xs')]: {
        fontSize: '16px',
      },
    },
    description: {
      color: '#A84308',
      fontWeight: 400,
      fontSize: '16px',
    },
  })
);

const MainPayments = () => {
  const classes = useStyle();

  return (
    <>
      <SubHeader
        content={
          <Box>
            <Typography variant="h6"> Pagos </Typography>
          </Box>
        }
      ></SubHeader>

      <Box my={3}>
        <Grid container justify="center">
          <Grid item xs={11}>
            <Grid container>
              {CARDS.map((card: any, index: number) => (
                <Grid item xs={12} sm={6} key={index.toString()}>
                  <Box my={3} mr={3} /* onClick={() => cardTag(card)} */>
                    <ButtonBase
                      component={RouterLink}
                      to={card.link}
                      //onClick={() => handlePush(card.title, card.link)}
                      style={{ width: '100%' }}
                    >
                      <SuraCard className={classes.suraCard}>
                        <Box
                          m={1}
                          marginLeft="16px"
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Box>
                              {' '}
                              <img src={card.image} alt={card.title}></img>{' '}
                            </Box>
                            <Box ml={3}>
                              <Typography className={classes.title}>
                                {' '}
                                {card.title}{' '}
                              </Typography>
                              <Typography className={classes.description}>
                                {' '}
                                {card.content}{' '}
                              </Typography>
                            </Box>
                          </Box>
                          <Box>
                            <RightIcon></RightIcon>
                          </Box>
                        </Box>
                      </SuraCard>
                    </ButtonBase>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default MainPayments;
